import * as Bowser from 'bowser';

const browser: any = Bowser.getParser(window.navigator.userAgent);
export const browserParser: Bowser.Parser.Parser = Bowser.getParser(window.navigator.userAgent);
const EDGE_NAME = 'edge';
const SAFARI_NAME = 'safari';
const IOS_NAME = 'ios';

export function isEdge(): boolean {
  return browser.isBrowser(EDGE_NAME, true);
}
export function isSafari(): boolean {
  return browser.isBrowser(SAFARI_NAME, true);
}
export function isIOS(): boolean {
  return browser.getOSName(true) === IOS_NAME;
}
export function isIE(): boolean {
  return browserParser.is('internet explorer');
}
